import MaxDepthList from './MaxDepthList';
import React from 'react';
import TableWrapRows from '../../StockItems/TableWrapRows';

export default function RawTree(props){

  var titleProp = props.titleProp;
  var treeData = props.treeData;
  var colorLines = props.colorLines;
  var needGap = props.needGap;
  var m = MaxDepthList(treeData);
  var colors = ['#000000', '#FF0000', '#00FF00', '#0000FF'];
  function articulateBorder(j){
    if (colorLines){
      var p = colors[j % 4];
      return '1px solid ' + p;
    }else{
      return '1px solid';
    }
  }

  var gap = null;
  if (needGap){
    gap = <span>&nbsp;</span>
  }
//

  function doANodeWithChildren(aNode, index, rows, nodeHere){
        var title = titleProp(aNode, nodeHere);
        var nodeText = nodeHere.map((aN, index)=>{return aN.i}).join(' ');
  //      

        var nosCellsBefore = [];
        var nosCellsBefore1 = [];
        for (var j = 0; j < nodeHere.length ; j++){
          var borderRight = null;
          var s =  articulateBorder(j);
          if (!nodeHere[j].isLast || (nodeHere.length -1 === j)){
              borderRight = s;
          }

          var borderBottom = false;
          if (j === nodeHere.length-1){
              borderBottom = s;
          }
          var dustbin;
          // if (canMove){
          //   dustbin = <Dustbin nodeHere={nodeHere} nosIn={j} setOverlayLocation={setOverlayLocation}/>
          // }
//
          nosCellsBefore.push(<td key={'a'+j+'_'+index} style={{borderRight}}>{dustbin}</td>)
//
          // nosCellsBefore.push(<td key={'a'+j+'_'+index} style={{borderRight}}>&nbsp;&nbsp;&nbsp;</td>)
//
          nosCellsBefore.push(<td key={'b'+j+'_'+index} style={{borderBottom, paddingLeft:'5px'}}>{gap}</td>)
//
          var borderRight1 = null;
          if (!nodeHere[j].isLast ){
              borderRight1 =  s;
          }
          nosCellsBefore1.push(<td key={'a'+j+'_'+index} style={{borderRight:borderRight1, paddingLeft:'5px'}}>{gap}</td>)
//
            nosCellsBefore1.push(<td key={'b'+j+'_'+index} style={{paddingLeft:'5px'}}>{gap}</td>)
        }
  //      
  //

            // <Box contents={title} setWhatsDragging={setWhatsDragging} aNode={aNode} />
        rows.push(<tr key={'a'+ index + '_'+nodeText}>{nosCellsBefore}<td rowSpan='2' colSpan={2 + 2 * (m - nodeHere.length)} style={{paddingTop:'0px', textAlign:'left'}} >
            {title}
          </td></tr>)
        // rows.push(<tr key={'a'+nodeText}>{nosCellsBefore}<td rowSpan='2' colSpan={2 + 2 * (m - nodeHere.length)} style={{paddingTop:'5px'}} >{title}
        //   </td></tr>)
        var bLabel = 'b'+ index + '_' +nodeText;
        rows.push(<tr key={bLabel}>{nosCellsBefore1}</tr>)
  //
        if (aNode.c && aNode.xx){
          showASetOfTrees(aNode.c, nodeHere, rows); 
        }

  }


    function showASetOfTrees(list, depthList, rows){

      return list.forEach((aNode, index)=>{
        var nodeHere = depthList.concat([{i:index, isLast:+index === list.length - 1}]);
        doANodeWithChildren(aNode, index, rows, nodeHere);
      })
    }


  var rows = [];
  showASetOfTrees(treeData, [], rows);

  return <TableWrapRows rows={rows}/>

  }
